import React from 'react'

import { useT } from './hooks'

export const withT = WrapperComponent => (props) => {
  const t = useT()
  return <WrapperComponent { ...props } t={ t } />
}
